const REMOVED_JOB_PARENTS = new Set(["similarity", "aizynthfinder"]);

const REMOVED_RESULT_KEYS = new Set([
  "arthor",
  "similarity_data",
  "sml_data",
  "synthesizer",
  "synthesizer_input",
  "aizynth_input",
]);

const REMOVED_RESULT_PREFIXES = ["sml_", "syr_", "similarity_", "aizynth"];

const normalizeKey = (key = "") => String(key).toLowerCase();

export const isRemovedJobParent = (parent) => REMOVED_JOB_PARENTS.has(normalizeKey(parent));

export const isRemovedJobDataKey = (key = "") => {
  const normalized = normalizeKey(key);
  return (
    isRemovedJobParent(normalized) ||
    REMOVED_RESULT_KEYS.has(normalized) ||
    REMOVED_RESULT_PREFIXES.some((prefix) => normalized.startsWith(prefix))
  );
};

export const sanitizeRemovedJobKeys = (keys = []) =>
  Array.from(new Set((Array.isArray(keys) ? keys : []).filter((key) => key && !isRemovedJobDataKey(key))));

export const sanitizeRemovedJobResultRow = (row) => {
  if (!row || typeof row !== "object" || Array.isArray(row)) return row;
  return Object.fromEntries(
    Object.entries(row).filter(([key]) => !isRemovedJobDataKey(key))
  );
};
